import React from 'react';
import classNames from 'classnames';

type PagesIndicatorProps = {
    pageCount: number;
    activeItemIndex: number;
    isTransparent?: boolean;
    onItemClick: (arg: number) => void;
};

const PagesIndicator = ({
    pageCount = 1,
    activeItemIndex,
    isTransparent,
    onItemClick
}: PagesIndicatorProps) => {
    const indicators: any = [];
    if (pageCount > 1) {
        for (let i = 0; i < pageCount; i += 1) {
            indicators.push(
                <span
                    key={i}
                    onClick={onItemClick.bind(null, i)}
                    className={classNames(
                        { active: i === activeItemIndex },
                        { 'is-transparent': isTransparent }
                    )}
                    role="button"
                    tabIndex={0}
                />
            );
        }
    }

    return (
        // TODO: here removed styled component logic for styling, used class for another component
        // we need to set 1 component only
        <div
            className={classNames('b-pages-indicator awc-pages-indicator', {
                'is-hidden': pageCount < 2
            })}
        >
            {indicators}
        </div>
    );
};

export default PagesIndicator;
